import { render } from "./CreateAnnotationSetModal.vue?vue&type=template&id=5e16605c&scoped=true"
import script from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"
export * from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"

import "./CreateAnnotationSetModal.vue?vue&type=style&index=0&id=5e16605c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e16605c"]])

export default __exports__